import React, { Fragment, useState, useEffect } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate, useLocation } from "react-router";
import FInfoCard from "../../components/FInfoCard/FInfoCard";
import { useFormik } from "formik";
import Floading from "../../components/Floading/Floading";
import Swal from "sweetalert2";
import FiconPhoneNumber from "../../components/FiconPhoneNumber/FiconPhoneNumber";
import PhoneInput from "react-phone-input-2";
import FInput from "../../components/FInput/FInput";
import OTPToken from "../OTPToken/OTPToken";
import { emailOTPSendCode } from "../../api/contactInfo";

const PhoneOTPScreen = ({ param }) => {
  const route = useNavigate();
  const parameters = useLocation();

  return (
    <>
      <OTPToken screen="PhoneOTPScreen" parameters={parameters.state} />
    </>
  );
};

export default PhoneOTPScreen;
